'use client';

import React from 'react';
import { AuthContextValue, defaultAuthContext } from '@/context/auth';
import {
  defaultJobTitleContext,
  JobTitleContextValue,
} from '@/context/job-title';
import { CityContextType, defaultCityContextValue } from '@/context/city';
import {
  defaultProfileValue,
  ProfileBuilderContextValue,
} from '@/context/profile-builder';
import {
  defaultEmployerContext,
  EmployerContextValue,
} from '@/context/employer';

export const AuthContext =
  React.createContext<AuthContextValue>(defaultAuthContext);

export const JobTitleContext = React.createContext<JobTitleContextValue>(
  defaultJobTitleContext,
);

export const CityContext = React.createContext<CityContextType>(
  defaultCityContextValue,
);

export const ProfileBuilderContext =
  React.createContext<ProfileBuilderContextValue>({
    profile: defaultProfileValue,
    setProfile: () => {},
    saveProfile: () => new Promise(() => {}),
  });

export const EmployerContext = React.createContext<EmployerContextValue>(
  defaultEmployerContext,
);
